import React, { useContext } from 'react'
import { Col, Row } from 'reactstrap'
import tshirt from '../../../assets/images/dummyImages/t-shirt-1.jpg'
import { LiveNewPrice, LiveOrgPrice, LiveProdCard, LiveProdName, LiveVisitStore, LiveWatch, SuccessText } from '../../../StyledComponents'
import Rating from 'react-rating'
import { Star } from 'react-feather'
import { ThemeColors } from '@src/utility/context/ThemeColors'
import like from '../../../assets/images/icons/like.svg'
import share from '../../../assets/images/icons/share.svg'


const LivePopup = () => {

    const themeColors = useContext(ThemeColors)
    
    return (
        <>
            <div className='p-2'>
                <Row flex>
                    <Col xl='3' lg='3' md='12' sm='12' xs='12'>
                        <LiveProdCard >
                            <Row>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-around', height:'100%'}}>
                                    <div>
                                        <LiveProdName>BB Cream</LiveProdName>
                                        <LiveOrgPrice>$49.99</LiveOrgPrice>
                                        <LiveNewPrice>$33.99</LiveNewPrice>
                                    </div>
                                    <div>
                                    <Rating
                                        readonly={true}
                                        initialRating={4}
                                        emptySymbol={<Star size={15} fill='#babfc7' stroke='#babfc7' />}
                                        fullSymbol={<Star size={15} fill={themeColors.colors.warning.main} stroke={themeColors.colors.warning.main} />}
                                        /> (84)
                                    </div>
                                </div>
                                </Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                    <img  src={tshirt} className='img-fluid card-img-top responsive' />
                                </Col>
                            </Row>
                        </LiveProdCard>
                        <div style={{display:'flex', justifyContent:'center', fontSize:'12px', fontWeight:'500', padding:'0.5rem'}}>Featuring Now</div>
                        
                        <div style={{display:'flex', justifyContent:'center', fontSize:'12px', fontWeight:'600', marginTop:'1.5rem', marginBottom:'10px', }}>Other Products from Same Seller/Brand</div>
                        
                        <LiveProdCard style={{marginBottom:'10px'}}>
                            <Row>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-around', height:'100%'}}>
                                    <div>
                                        <LiveProdName>BB Cream</LiveProdName>
                                        <LiveOrgPrice>$49.99</LiveOrgPrice>
                                        <LiveNewPrice>$33.99</LiveNewPrice>
                                    </div>
                                    <div>
                                    <Rating
                                        readonly={true}
                                        initialRating={4}
                                        emptySymbol={<Star size={15} fill='#babfc7' stroke='#babfc7' />}
                                        fullSymbol={<Star size={15} fill={themeColors.colors.warning.main} stroke={themeColors.colors.warning.main} />}
                                        /> (84)
                                    </div>
                                </div>
                                </Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                    <img  src={tshirt} className='img-fluid card-img-top responsive' />
                                </Col>
                            </Row>
                        </LiveProdCard>

                        <LiveProdCard style={{marginBottom:'10px'}}>
                            <Row>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-around', height:'100%'}}>
                                    <div>
                                        <LiveProdName>BB Cream</LiveProdName>
                                        <LiveOrgPrice>$49.99</LiveOrgPrice>
                                        <LiveNewPrice>$33.99</LiveNewPrice>
                                    </div>
                                    <div>
                                    <Rating
                                        readonly={true}
                                        initialRating={4}
                                        emptySymbol={<Star size={15} fill='#babfc7' stroke='#babfc7' />}
                                        fullSymbol={<Star size={15} fill={themeColors.colors.warning.main} stroke={themeColors.colors.warning.main} />}
                                        /> (84)
                                    </div>
                                </div>
                                </Col>
                                <Col xl='6' lg='6' md='6' sm='12' xs='12' >
                                    <img  src={tshirt} className='img-fluid card-img-top responsive' />
                                </Col>
                            </Row>
                        </LiveProdCard>
                        
                        <LiveVisitStore>Visit Store</LiveVisitStore>

                    </Col>
                    <Col xl='9' lg='9' md='12' sm='12' xs='12'>
                        <video
                            style={{ maxWidth: "100%", width: "auto", margin: "0 auto" }}
                            playsInline
                            loop
                            muted
                            alt="Live Video"
                            controls
                            autoPlay
                            controlsList="nodownload noremoteplayback"
                            src="https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"
                        />
                        <LiveWatch>
                            <SuccessText>30 People Watching</SuccessText>
                            <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
                                <div style={{marginRight:'8px'}}>
                                    <div style={{display:"flex", alignItems:'flex-end'}}>
                                        <SuccessText style={{marginRight:'5px'}}>30</SuccessText>
                                        <img width={'20px'} height={'20px'} src={like}/>
                                    </div>
                                </div>
                                <div>
                                    <div style={{display:"flex", alignItems:'flex-end'}}>
                                        <SuccessText style={{marginRight:'5px'}}>4</SuccessText>
                                        <img width={'20px'} height={'20px'} src={share}/>
                                    </div>
                                </div>
                            </div>
                        </LiveWatch>
                    </Col>
                </Row>
            </div>
        </>
    )
}
export default LivePopup